import { createReducer } from '@reduxjs/toolkit'
import { addUser, setAuthenticated, setUserPolicies } from '../actions/auth'
import { isDevelop } from '../utils/Common'
import { User } from '../models/Organization'

const initialState: UserState = {
  authenticated: isDevelop(),
}

interface UserState {
  authenticated: boolean
  user?: User
}

const authReducer = createReducer(initialState, (builder) => {
  builder.addCase(setAuthenticated, (state, action) => {
    state.authenticated = action.payload
  })
  builder.addCase(addUser, (state, action) => {
    state.user = action.payload
  })
  builder.addCase(setUserPolicies, (state, action) => {
    if (!state.user) {
      return
    }

    state.user.role.AccessPolicy = action.payload
  })
})

export default authReducer
